import React, { useState } from 'react';
import ContactStep from '../userauthorization/importPermissionsGroups/steps/ContactStep';
import { USERTYPE } from '../EnumUserType';
import AddAuthorization from '../userauthorization/AddAuthorization';
import Confirm from '../../../core/components/forked/layout/Confirm';

const SelectPermissionGroupsStep = props => {
  const {
    onSubmitEnd,
    permissions,
    contactCreated,
    creation,
    selectedPermissionGroups,
    setSelectedPermissionGroups,
    selectedAssignmentMode,
    setSelectedContactForImport,
    confirmWarningIsOpen,
    handleConfirmWarningClose,
    setSelectedAssignmentMode,
    clearStates,
    setIsNewImportToDo
  } = props;
  const { userType, userId } = contactCreated;
  const filter = { userId: userId };
  const groupsFilter = 'ALL';
  const [userToCopy, setUserToCopy] = useState(null);

  const userTypeRoleCheck =
    userType === USERTYPE.regularContact || userType === USERTYPE.investorAdmin;

  const updateUser = user => {
    setUserToCopy(user);
  };

  if (selectedAssignmentMode === 'manual' || confirmWarningIsOpen) {
    return (
      <>
        <AddAuthorization
          userTypeRoleCheck={userTypeRoleCheck}
          onSubmitEnd={onSubmitEnd}
          permissions={permissions}
          userType={userType}
          id={userId}
          filter={filter}
          groupsFilter={groupsFilter}
          creation={creation}
          selectedPermissionGroups={selectedPermissionGroups}
          setSelectedPermissionGroups={setSelectedPermissionGroups}
        />
        <Confirm
          isOpen={confirmWarningIsOpen}
          title="Warning"
          content={
            <p style={{ margin: 0 }}>
              All Permission Groups assigned to this Contact will be merged with
              the ones you import. Do you wish to continue?
            </p>
          }
          onConfirm={() => {
            handleConfirmWarningClose();
            clearStates();
            setSelectedAssignmentMode('import');
          }}
          onClose={handleConfirmWarningClose}
        />
      </>
    );
  } else {
    return (
      <ContactStep
        isRegular={userTypeRoleCheck}
        userId={userId}
        updateUser={updateUser}
        creation={creation}
        userToCopy={userToCopy}
        setSelectedContactForImport={setSelectedContactForImport}
        setIsNewImportToDo={setIsNewImportToDo}
      />
    );
  }
};

export default SelectPermissionGroupsStep;
